<style lang="scss">
  @import "@/assets/scss/vuexy/components/valueItem";
</style>
<template>
  <div class="p-2">
      <div class="device-info vx-col w-full">
          <div class="shadow-drop d-theme-dark-bg round">
              <img :src="getImgUrl(img)" class="info-icon p-2 block"/>
          </div>
          <div class="device-text-container" v-if="!relativeTime">
              <span class="main-info">
                  {{ value }} <span class="unit">{{unit}}</span>
              </span>
              <span class="subtext-info">
                  {{description}}
              </span>
          </div>
          <div class="device-text-container" v-if="relativeTime">
              <span class="main-info">
                  {{relativeTimeConvert(value)}}
              </span>
          </div>
      </div>
  </div>
</template>
<script>
export default {
  props:{
    value: String,
    unit: String,
    img: String,
    description: String,
    min: String,
    max: String,
    relativeTime: Boolean
  },
  methods: {
    getImgUrl (name) {
      const val = parseFloat(this.value)
      const min = parseFloat(this.min)
      const max = parseFloat(this.max)
      const images = require.context('@/assets/images/icons/', false, /\.svg$/)
      if (this.min !== null && this.max !== null) {
        let color = ''
        if (val < min) color = 'blue' 
        else if (val > max) color = 'red'
        else color = 'gray'
        return images(`./${  name  }_${  color  }.svg`)
      } else {
        return images(`./${  name  }.svg`)
      }
       
    },
    relativeTimeConvert (date) {
      date.replace(' ', 'T')
      return this.$dayjs().to(this.$dayjs(date))
    }
  }
}
</script>
